import CottageIcon from "@mui/icons-material/Cottage";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PersonIcon from "@mui/icons-material/Person";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography
} from "@mui/material";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { ButtonCompo } from "../../components/Comman/Button";
import BasicDatePicker from "../../components/Comman/DatePickerEx";
import {
  MyComponentWithIconProps
} from "../../components/Comman/IconButton";
import { LabelCompo } from "../../components/Comman/Label";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import {
  blackColor,
  brownishRed,
  cyanBlue,
  DarkBlue,
  greyColor,
  lightGreen,
  lightOrange,
  lightSkyBlue,
  pastelPink,
  periwinkleblue,
  redColor,
  titleColor,
  vividGreen,
  white,
  yellowColor
} from "../../config/ColorObj";
import endpoint from "../../config/endpoints";
import {
  dataNotFoundMsg,
  fromdateMsg,
  noInternetMsg,
  serverMsg,
  todateMsg,
} from "../../config/messageconstant";
import checkInImg from "../../Images/check_in.png";
import distributorImg from "../../Images/distributor.png";
import checkOutImg from "../../Images/imageRed.png";
import jointWorkImg from "../../Images/joint_work.png";
import officeWorkImg from "../../Images/office_work.png";
import otherWorkImg from "../../Images/other_work.png";
import retailingImg from "../../Images/retailing.png";
import unVisitedOutletIcon from "../../Images/UnvisitedOutletsIcon.png";
import zeroOrderIconImg from "../../Images/zeroOrderIcon.png";
import {
  showLoador,
  showNotification,
} from "../../Pages/Landing/Landing.slice";
import {
  getTimelineForSalesExecutive,
} from "../../Slice/location.slice";
import {
  getManagerLogsBySalesTeamIdsUpdated,
  getTimeLineForBelowSalesTeamsAndDates,
  setManagerLogs,
} from "../../Slice/managerLogs.slice";
import { apiGet } from "../../utils/api_service";
import FeedbackImage from "../DashbourdChanges/FeedbackImage";
import SalesPersonCheckInImage from "../DashbourdChanges/SalesPersonCheckInImage";
import ZeroOrderImage from "../DashbourdChanges/ZeroOrderImage";
import TimelineDetailsPopup from "./TimelineDetailsPopup";
import PromotoerDataPopUp from "../DashbourdChanges/PromotoerDataPopUp";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
const Timeline = ({
  showNotification,
  outletDetails,
  location,
  showLoador,
  getTimelineForSalesExecutive,
  getManagerLogsBySalesTeamIdsUpdated,
  getTimeLineForBelowSalesTeamsAndDates,
  setManagerLogs,
  managerLogsList,
  saveData,
  dateFlag,
  handleTabData,
  handleTabDataForTimeDelay,
  onSearchData,
  onInitialTimelineData,
  onChangeCheckbox,
  onActivitySelect,
  pathCoords,
}) => {
  const params = useParams();
  const [value, setValue] = useState(0);
  const [rows, setRows] = useState([]);
  const [fromdate, setFromdate] = useState("");
  const [todate, setTodate] = useState("");
  const [date, setDate] = useState("");
  const [popUpFlag, setPopUpFlag] = useState(false);
  const [salesPersonCheckInImageFlag, setSalesPersonCheckInImageFlagFlag] =
    useState(false);
  const [zeroOrderImgOpenFlag, setZeroOrderImgOpenFlag] = useState(false);
  const [promoterDataPopUpFlag, setPromoterDataPopUpFlag] = useState(false);
  const [feedbackImgOpenFlag, setFeedbackImgOpenFlag] = useState(false);
  const [
    hideColumnsAtTimelineDetailsPopUp,
    setHideColumnsAtTimelineDetailsPopUp,
  ] = useState(false);
  const [itemObj, setItemObj] = useState({});
  const [showTimelineManagerLogs, setShowTimelineManagerLogs] = useState("");
  const [checkInImageFlag, setCheckInImageFlag] = useState("");
  const [zeroOrderImageFlag, setZeroOrderImageFlag] = useState("");
  const [DataToSet, setDataToSet] = useState([]);
  const [dataToSetPastOrder, setDataToSetPastOrder] = useState([]);
  const [outletOrderDetails, setOutletOrderDetails] = useState([]);
  const [appliedOfferDetails, setAppliedOfferDetails] = useState([]);
  const [outletOrderDetailsPastOrder, setOutletOrderDetailsPastOrder] =
    useState([]);
  const [appliedOfferDetailsPastOrder, setAppliedOfferDetailsPastOrder] =
    useState([]);
  const [formErrors, setFormErrors] = React.useState({});
  const [showPastOrderInTimeline, setShowPastOrderInTimeline] = useState("");
  const [onSearchLocation, setOnSearchLocation] = useState(false);
  const [salesTeamData, setSalesTeamData] = useState({});
  const [selectedBeatData, setSelectedBeatData] = useState("");
  const [selectedBeatArea, setSelecedBeatArea] = useState("");
  const [distanceTravelled, setDistanceTravelled] = useState("");
  const [selectedDate, setSelectedDate] = useState(
    dayjs().format("DD-MM-YYYY")
  );
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  // Keep map option checkboxes disabled until timeline API finishes successfully
  const [areMapOptionsReady, setAreMapOptionsReady] = useState(false);

  const handleToggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const navigate = useNavigate();

  useEffect(() => {
    fetchSetting();
  }, []);

  const fetchSetting = async () => {

    const zeroOrderImage = localStorage.getItem("zeroOrderImage");
    setZeroOrderImageFlag(zeroOrderImage);

    const checkInImage = localStorage.getItem("checkInImage");
    setCheckInImageFlag(checkInImage);

    const pastOrderInTimeline = localStorage.getItem("showPastOrderInTimeline");
    setShowPastOrderInTimeline(pastOrderInTimeline);

    setManagerLogs({ row: [] });

    const localStorageKey = localStorage.getItem("showTimelineManagerLogsWise");
    let settingValueToShowTimeLine;

    if (localStorageKey !== null) {
      settingValueToShowTimeLine = localStorageKey;
      setShowTimelineManagerLogs(settingValueToShowTimeLine);

      if (settingValueToShowTimeLine == 0) {
        if (rows.length === 0) {
          getTimelineList();
        }
      } else {
        getManagerLogsList();
      }
    } else {
      showLoador({ loador: true });
      apiGet({
        url: endpoint.setting + "/by-key?key=show_timeline_manager_logs_wise",
      }).then(({ data, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          if (data && data.data && Object.keys(data.data).length != 0) {
            if (data.data.settingValue) {
              settingValueToShowTimeLine = data.data.settingValue;

              setShowTimelineManagerLogs(settingValueToShowTimeLine);

              if (settingValueToShowTimeLine == 0) {
                if (rows.length === 0) {
                  getTimelineList();
                }
              } else {
                getManagerLogsList();
              }
            }
          }
        }
      });
    }
  };

  const onCancel = () => {
    navigate(-1);
  };
  const getTimelineList = () => {
    const selectedDay = location.salesTeamTimeline[value]?.day;
    if (navigator.onLine) {
      showLoador({ loador: true });
      getTimelineForSalesExecutive({
        fromDate: "",
        toDate: "",
        salesTeamIds: params.id,
        selectedDay,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          const newRows = response.map((rowData, index) => ({
            ...rowData,
            index,
          }));
          setRows(newRows);
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  const getManagerLogsList = () => {
    const showRealTimeTracking = localStorage.getItem("showRealTimeTracking");
    if (navigator.onLine) {
      if (showRealTimeTracking && showRealTimeTracking == 1) {
        let salesTeamData = {};
        let beatNames = "";
        let areaNames = "";
        let distanceTravelled = 0;

        setAreMapOptionsReady(false);
        showLoador({ loador: true });
        getTimeLineForBelowSalesTeamsAndDates({
          fromDate: dayjs().format("DD-MM-YYYY"),
          toDate: dayjs().format("DD-MM-YYYY"),
          salesTeamId: params.id,
          flag: 0,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            const managerLogCurrentRow = response.map((rowData, index) => ({
              ...rowData,
              index,
            }));

            setRows(managerLogCurrentRow);

            if (response.length !== 0) {
              response.map((dataObj) => {
                salesTeamData = {
                  salesTeamId: dataObj.salesTeamId,
                  salesTeamName: dataObj.salesTeamName,
                  salesTeamType: dataObj.salesTeamType,
                  salesTeamLatitude: dataObj.latitude,
                  salesTeamLongitude: dataObj.longitude,
                  salesTeamHomeAddress: dataObj.homeAddress,
                };
              });

              setSalesTeamData(salesTeamData);
            }

            // below condition was commented by Ritesh as suggested by Tejas
            // if (params.userTypeId == "4") {
            if (response.length !== 0) {
              response.map((dataObj) => {
                beatNames = dataObj.beatNames;
                areaNames = dataObj.areaNames;
                distanceTravelled = dataObj.distanceTravelled || 0;
              });

              setSelectedBeatData(beatNames);
              setSelecedBeatArea(areaNames);
              setDistanceTravelled(distanceTravelled);
            }
            // }
            
            onInitialTimelineData?.(response);
            setAreMapOptionsReady(true);
          }
        });
      } else {
        let salesTeamData = {};
        let beatNames = "";
        let areaNames = "";
        let distanceTravelled = 0;

        showLoador({ loador: true });
        getManagerLogsBySalesTeamIdsUpdated({
          fromDate: dayjs().format("DD-MM-YYYY"),
          toDate: dayjs().format("DD-MM-YYYY"),
          salesTeamId: params.id,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            const managerLogCurrentRow = response.map((rowData, index) => ({
              ...rowData,
              index,
            }));

            setRows(managerLogCurrentRow);

            if (response.length !== 0) {
              response.map((dataObj) => {
                salesTeamData = {
                  salesTeamId: dataObj.salesTeamId,
                  salesTeamName: dataObj.salesTeamName,
                  salesTeamType: dataObj.salesTeamType,
                };
              });

              setSalesTeamData(salesTeamData);
            }

            // below condition was commented by Ritesh as suggested by Tejas
            // if (params.userTypeId == "4") {
            if (response.length !== 0) {
              response.map((dataObj) => {
                beatNames = dataObj.beatNames;
                areaNames = dataObj.areaNames;
                distanceTravelled = dataObj.distanceTravelled || 0;
              });

              setSelectedBeatData(beatNames);
              setSelecedBeatArea(areaNames);
              setDistanceTravelled(distanceTravelled);
            }
            // }
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  const changeDate = (name) => (date) => {
    if (name === "fromdate") {
      setFromdate(date);
    } else if (name === "todate") {
      setTodate(date);
    }
  };

  const checkValidation = () => {
    let formErrors = {};
    let formIsValid = true;

    if (fromdate === "") {
      formIsValid = false;
      formErrors["fromdateError"] = fromdateMsg;
    }
    if (todate === "") {
      formIsValid = false;
      formErrors["todateError"] = todateMsg;
    }
    setFormErrors(formErrors);
    return formIsValid;
  };

  const searchData = () => {
    const selectedDay = location.salesTeamTimeline[value]?.day;

    const showRealTimeTracking = localStorage.getItem("showRealTimeTracking");

    if (navigator.onLine) {
      if (checkValidation()) {
        setRows([]);

        if (showTimelineManagerLogs && showTimelineManagerLogs == 0) {
          showLoador({ loador: true });
          getTimelineForSalesExecutive({
            fromDate: dayjs(fromdate).format("DD-MM-YYYY"),
            toDate: dayjs(todate).format("DD-MM-YYYY"),
            salesTeamIds: params.id,
            selectedDay,
          }).then(({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              const newRowsOnSearch = response.map((rowData, index) => ({
                ...rowData,
                index,
              }));
              setRows(newRowsOnSearch);
            }
          });
        } else {
          if (showRealTimeTracking && showRealTimeTracking == 1) {
            let salesTeamData = {};

            setAreMapOptionsReady(false);
            showLoador({ loador: true });
            getTimeLineForBelowSalesTeamsAndDates({
              fromDate: dayjs(fromdate).format("DD-MM-YYYY"),
              toDate: dayjs(todate).format("DD-MM-YYYY"),
              salesTeamId: params.id,
              flag: 0,
            }).then(({ response, success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              } else {
                const managerLogOnSearchRow = response.map(
                  (rowData, index) => ({
                    ...rowData,
                    index,
                  })
                );

                onSearchDataMethod(managerLogOnSearchRow);
                setOnSearchLocation(true);
                setRows(managerLogOnSearchRow);

                if (response.length !== 0) {
                  response.map((dataObj) => {
                    salesTeamData = {
                      salesTeamId: dataObj.salesTeamId,
                      salesTeamName: dataObj.salesTeamName,
                      salesTeamType: dataObj.salesTeamType,
                      salesTeamLatitude: dataObj.latitude,
                      salesTeamLongitude: dataObj.longitude,
                      salesTeamHomeAddress: dataObj.homeAddress,
                    };
                  });

                  setSalesTeamData(salesTeamData);
                }

                // below condition was commented by Ritesh as suggested by Tejas
                // if (params.userTypeId == "4") {
                if (response.length !== 0) {
                  setSelectedBeatData(response[0].beatNames);
                  setSelecedBeatArea(response[0].areaNames);
                  setDistanceTravelled(response[0].distanceTravelled || 0)
                }
                // }
                setAreMapOptionsReady(true);
              }
            });
          } else {
            let salesTeamData = {};
            showLoador({ loador: true });
            getManagerLogsBySalesTeamIdsUpdated({
              fromDate: dayjs(fromdate).format("DD-MM-YYYY"),
              toDate: dayjs(todate).format("DD-MM-YYYY"),
              salesTeamId: params.id,
            }).then(({ response, success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              } else {
                const managerLogOnSearchRow = response.map(
                  (rowData, index) => ({
                    ...rowData,
                    index,
                  })
                );

                onSearchDataMethod(managerLogOnSearchRow);
                setOnSearchLocation(true);
                setRows(managerLogOnSearchRow);

                if (response.length !== 0) {
                  response.map((dataObj) => {
                    salesTeamData = {
                      salesTeamId: dataObj.salesTeamId,
                      salesTeamName: dataObj.salesTeamName,
                      salesTeamType: dataObj.salesTeamType,
                    };
                  });

                  setSalesTeamData(salesTeamData);
                }

                // below condition was commented by Ritesh as suggested by Tejas
                // if (params.userTypeId == "4") {
                if (response.length !== 0) {
                  setSelectedBeatData(response[0].beatNames);
                  setSelecedBeatArea(response[0].areaNames);
                  setDistanceTravelled(response[0].distanceTravelled || 0)
                }
                // }
              }
            });
          }
        }
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };



  const onSearchDataMethod = (dataList) => {
    setSelectedOption(null);
    onSearchData(dataList);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);

    const selectedManagerLog = managerLogsList.managerLogs[newValue];

    if (selectedManagerLog) {
      setSelectedBeatData(selectedManagerLog.beatNames);
      setSelecedBeatArea(selectedManagerLog.areaNames);
      setSelectedDate(selectedManagerLog.date);
      setDistanceTravelled(selectedManagerLog.distanceTravelled);
      setSelectedOption(null);
    } else {
      setSelectedBeatData("-");
      setSelecedBeatArea("-");
      setDistanceTravelled(0);
    }

    saveData(newValue + 1, rows);
  };

  const timelineDetails = async (row) => {
    if (navigator.onLine) {
      setDataToSet([]);
      setOutletOrderDetails([]);
      setAppliedOfferDetails([]);

      setDataToSetPastOrder([]);
      setOutletOrderDetailsPastOrder([]);


      if (row.type == 0 && showTimelineManagerLogs == 0) {
        let orderTime =
          row.dateAndTime !== null
            ? row.dateAndTime.split(" ")[0]
            : dayjs().format("DD-MM-YYYY");

        showLoador({ loador: true });
        apiGet({
          url:
            endpoint.outlet +
            "/basic-info-by-outlet-sales-team-and-date?outletId=" +
            row.outletId +
            "&salesTeamId=" +
            params.id +
            "&date=" +
            orderTime,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
          } else {
            const commonData = [
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Date",
                value: orderTime,
              },
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Beat Name",
                value: data.data.beatName !== null ? data.data.beatName : "-",
              },
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Outlet Name",
                value: data.data.firmName !== null ? data.data.firmName : "-",
              },
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Owner Name",
                value: data.data.ownerName !== null ? data.data.ownerName : "-",
              },
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Address",
                value: data.data.address !== null ? data.data.address : "-",
              },
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Mobile No",
                value: data.data.mobileNo !== null ? data.data.mobileNo : "-",
              },
              {
                xs: 12,
                sm: 4,
                md: 4,
                lg: 4,
                label: "Remark",
                value:
                  data.data.stockStakeHolderId !== null
                    ? data.data.stockStakeHolderId
                    : "-",
              },
            ];
            setDataToSet(commonData);
            setPopUpFlag(true);
            setHideColumnsAtTimelineDetailsPopUp(true);
            setOutletOrderDetails([]);
            setAppliedOfferDetails([]);
            setDataToSetPastOrder([]);
            setOutletOrderDetailsPastOrder([]);
          }
        });
      } else {
        if (
          row.outletOrderHeaderId !== "" &&
          row.outletOrderHeaderId !== null
        ) {
          showLoador({ loador: true });
          await apiGet({
            url:
              endpoint.outletOrderHeader +
              "/get-by-id-new/" +
              row.outletOrderHeaderId,
          }).then(({ data, success }) => {
            if (success) {
              const commonData = [
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Order No",
                  value: data.data.orderNo !== null ? data.data.orderNo : "-",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Order Date",
                  value:
                    data.data.orderDate !== null ? data.data.orderDate : "-",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Beat Name",
                  value:
                    data.data.outLet !== null &&
                      data.data.outLet.beat !== null &&
                      data.data.outLet.beat.beatName !== null
                      ? data.data.outLet.beat.beatName
                      : "-",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Outlet Name",
                  value:
                    data.data.outLet !== null &&
                      data.data.outLet.firmName !== null
                      ? data.data.outLet.firmName
                      : "-",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Owner Name",
                  value:
                    data.data.outLet !== null &&
                      data.data.outLet.ownerName !== null
                      ? data.data.outLet.ownerName
                      : "-",
                },
                {
                  xs: 12,
                  sm: 4,
                  md: 4,
                  lg: 4,
                  label: "Mobile No",
                  value:
                    data.data.outLet !== null &&
                      data.data.outLet.mobileNo !== null
                      ? data.data.outLet.mobileNo
                      : "-",
                },
              ];

              const companyFlagData =
                showTimelineManagerLogs == 0
                  ? commonData
                  : [
                    ...commonData,
                    {
                      xs: 12,
                      sm: 4,
                      md: 4,
                      lg: 4,
                      label: "CD",
                      value:
                        data.data.distcountAmt !== null
                          ? data.data.distcountAmt
                          : "-",
                    },
                  ];

              setDataToSet(companyFlagData);

              const offerDetails = data.data.appliedOffers.map(
                (rowData, index) => {
                  return {
                    index: index + 1,
                    id: rowData.id,
                    name: rowData.name,
                  };
                }
              );

              setAppliedOfferDetails(offerDetails);

              (outletDetails = data.data.outletOrderDetails.map(
                (rowData, index) => {
                  let outletData = {
                    index: index + 1,
                    productName: rowData.product.name,
                    focusProduct: rowData.focusFlag == 1 ? "Yes" : "No",
                    uom: rowData.product.outletUom.name,
                    rate: rowData.rate.toFixed(2),
                    qty: rowData.qty,
                    discountPer: rowData.discountPer,
                    totalAmt: rowData.totalAmt.toFixed(2),
                  };
                  return outletData;
                }
              )),
                setOutletOrderDetails(outletDetails);
              setPopUpFlag(true);

              if (showPastOrderInTimeline == 1) {
                showLoador({ loador: true });
                apiGet({
                  url:
                    endpoint.outletOrderHeader +
                    "/last-visit-and-order-new?date=" +
                    dateFlag +
                    "&outletId=" +
                    row.outletId,
                }).then(({ data, success }) => {
                  if (success) {
                    if (
                      data &&
                      data.data &&
                      Object.keys(data.data).length !== 0
                    ) {
                      if (
                        data.data.isVisitIsOrder !== null &&
                        data.data.outletOrderHerader !== null
                      ) {
                        setDataToSetPastOrder([
                          {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "Order No",
                            value:
                              data.data.outletOrderHerader !== null &&
                                data.data.outletOrderHerader.orderNo !== null
                                ? data.data.outletOrderHerader.orderNo
                                : "",
                          },
                          {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "Order Date",
                            value:
                              data.data.outletOrderHerader !== null &&
                                data.data.outletOrderHerader.orderDate !== null
                                ? data.data.outletOrderHerader.orderDate
                                : "",
                          },
                          {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "Outlet Name",
                            value:
                              data.data.outletOrderHerader !== null &&
                                data.data.outletOrderHerader.outLet !== null &&
                                data.data.outletOrderHerader.outLet.firmName !==
                                null
                                ? data.data.outletOrderHerader.outLet.firmName
                                : "",
                          },
                          {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "CD",
                            value:
                              data.data.outletOrderHerader !== null &&
                                data.data.outletOrderHerader.distcountAmt !== null
                                ? data.data.outletOrderHerader.distcountAmt
                                : "-",
                          },
                        ]);

                        if (
                          data.data.outletOrderHerader &&
                          data.data.outletOrderHerader !== null
                        ) {
                          if (
                            data.data.outletOrderHerader.outletOrderDetails &&
                            data.data.outletOrderHerader.outletOrderDetails
                              .length !== 0
                          ) {
                            (outletDetails =
                              data.data.outletOrderHerader.outletOrderDetails.map(
                                (rowData, index) => {
                                  let outletData = {
                                    index: index + 1,
                                    productName: rowData.product.name,
                                    focusProduct:
                                      rowData.focusFlag == 1 ? "Yes" : "No",
                                    uom: rowData.product.outletUom.name,
                                    rate: rowData.rate.toFixed(2),
                                    qty: rowData.qty,
                                    discountPer: rowData.discountPer,
                                    totalAmt: rowData.totalAmt.toFixed(2),
                                  };
                                  return outletData;
                                }
                              )),
                              setOutletOrderDetailsPastOrder(outletDetails);

                            setPopUpFlag(true);
                          }

                          const offerDetailsPastOrder =
                            data.data.outletOrderHerader.appliedOffers.map(
                              (rowData, index) => {
                                let offerData = {
                                  index: index + 1,
                                  id: rowData.id,
                                  name: rowData.name,
                                };
                                return offerData;
                              }
                            );
                          setAppliedOfferDetailsPastOrder(
                            offerDetailsPastOrder
                          );
                        }
                        showLoador({ loador: false });
                      } else {
                        showLoador({ loador: false });
                        showNotification({
                          msg: "Past Order " + dataNotFoundMsg,
                          severity: "error",
                        });
                      }
                    } else {
                      showNotification({ msg: serverMsg, severity: "error" });
                    }
                  } else {
                    showLoador({ loador: false });
                    showNotification({ msg: serverMsg, severity: "error" });
                  }
                });
              }
              showLoador({ loador: false });
            } else {
              if (showPastOrderInTimeline == 1) {
                showLoador({ loador: true });
                apiGet({
                  url:
                    endpoint.outletOrderHeader +
                    "/last-visit-and-order-new?date=" +
                    dateFlag +
                    "&outletId=" +
                    row.outletId,
                }).then(({ data, success }) => {
                  if (success) {
                    if (
                      data &&
                      data.data &&
                      Object.keys(data.data).length !== 0
                    ) {
                      if (
                        data.data.isVisitIsOrder !== null &&
                        data.data.outletOrderHerader !== null
                      ) {
                        setDataToSetPastOrder([
                          {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "Order No",
                            value:
                              data.data.outletOrderHerader !== null &&
                                data.data.outletOrderHerader.orderNo !== null
                                ? data.data.outletOrderHerader.orderNo
                                : "",
                          },
                          {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "Order Date",
                            value:
                              data.data.outletOrderHerader !== null &&
                                data.data.outletOrderHerader.orderDate !== null
                                ? data.data.outletOrderHerader.orderDate
                                : "",
                          },
                          {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "Outlet Name",
                            value:
                              data.data.outletOrderHerader !== null &&
                                data.data.outletOrderHerader.outLet !== null &&
                                data.data.outletOrderHerader.outLet.firmName !==
                                null
                                ? data.data.outletOrderHerader.outLet.firmName
                                : "",
                          },
                          {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            lg: 4,
                            label: "CD",
                            value:
                              data.data.outletOrderHerader !== null &&
                                data.data.outletOrderHerader.distcountAmt !== null
                                ? data.data.outletOrderHerader.distcountAmt
                                : "-",
                          },
                        ]);

                        if (
                          data.data.outletOrderHerader &&
                          data.data.outletOrderHerader !== null
                        ) {
                          if (
                            data.data.outletOrderHerader.outletOrderDetails &&
                            data.data.outletOrderHerader.outletOrderDetails
                              .length !== 0
                          ) {
                            (outletDetails =
                              data.data.outletOrderHerader.outletOrderDetails.map(
                                (rowData, index) => {
                                  let outletData = {
                                    index: index + 1,
                                    productName: rowData.product.name,
                                    focusProduct:
                                      rowData.focusFlag == 1 ? "Yes" : "No",
                                    uom: rowData.product.outletUom.name,
                                    rate: rowData.rate.toFixed(2),
                                    qty: rowData.qty,
                                    discountPer: rowData.discountPer,
                                    totalAmt: rowData.totalAmt.toFixed(2),
                                  };
                                  return outletData;
                                }
                              )),
                              setOutletOrderDetailsPastOrder(outletDetails);
                            setPopUpFlag(true);
                          }

                          const offerDetailsPastOrder =
                            data.data.outletOrderHerader.appliedOffers.map(
                              (rowData, index) => {
                                let offerData = {
                                  index: index + 1,
                                  name: rowData.name,
                                };
                                return offerData;
                              }
                            );
                          setAppliedOfferDetailsPastOrder(
                            offerDetailsPastOrder
                          );
                        }
                        showLoador({ loador: false });
                      } else {
                        showLoador({ loador: false });
                        showNotification({
                          msg: dataNotFoundMsg,
                          severity: "error",
                        });
                      }
                    } else {
                      showNotification({ msg: serverMsg, severity: "error" });
                    }
                  } else {
                    showLoador({ loador: false });
                    showNotification({ msg: serverMsg, severity: "error" });
                  }
                });
              } else {
                showLoador({ loador: false });
                showNotification({ msg: serverMsg, severity: "error" });
              }
            }
          });

          setHideColumnsAtTimelineDetailsPopUp(false);
        } else {
          showNotification({ msg: dataNotFoundMsg, severity: "error" });
        }
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };
  const handleClose = () => {
    setPopUpFlag(false);
  };

  const handleClickOnProductCount = (itemObject) => {
    timelineDetails(itemObject);
  };

  const handleMainCheckboxChange = (optionValue) => {
    if (!areMapOptionsReady) return;
    onChangeCheckbox(optionValue, selectedOption, salesTeamData);
    if (selectedOption == optionValue) {
      setSelectedOption(null);
    } else {
      setSelectedOption(optionValue);
    }
  };

  const handleCheckboxChange = (img) => {
    setSelectedActivities((prev) => {
      let updated;
      if (prev.includes(img)) {
        updated = prev.filter((item) => item !== img);
      } else {
        updated = [...prev, img];
      }

      onActivitySelect(updated);
      return updated;
    });
  };

  const handleTabClick = (itemObject) => {
    handleTabData(itemObject);
  };

  const handleTabClickForTimeDelay = (itemObject) => {
    handleTabDataForTimeDelay(itemObject)
  }

  const handleCheckInClick = (itemObject) => {
    setSalesPersonCheckInImageFlagFlag(true);
    setItemObj(itemObject);
  };

  const handleZeroOrderImage = (itemObject) => {
    setZeroOrderImgOpenFlag(true);
    setItemObj(itemObject);
  };

  const handlePromoterData = (itemObject) => {
    setPromoterDataPopUpFlag(true)
    setItemObj(itemObject);
  }

  const handleFeedbackImage = (itemObject) => {
    setFeedbackImgOpenFlag(true);
    setItemObj(itemObject);
  };

  const handleClosesSalesPersonImage = () => {
    setSalesPersonCheckInImageFlagFlag(false);
  };

  const handleClosesZeroOrderImage = () => {
    setZeroOrderImgOpenFlag(false);
  };

  const handleClosesForFeedbackImage = () => {
    setFeedbackImgOpenFlag(false);
  };

  const handleClosesForPromoterDataPopUp = () => {
    setPromoterDataPopUpFlag(false);
  };

  const padTime = (timeStr) => {
    if (!timeStr) return "00:00:00";
    const parts = timeStr.split(":").map((part) => part.padStart(2, "0"));
    while (parts.length < 3) parts.unshift("00");
    return parts.join(":");
  };


  const formatGapTime = (gapTimeInMinutes = 0) => {
    const totalMinutes = Number(gapTimeInMinutes);

    if (totalMinutes < 60) {
      return `${totalMinutes} Min`;
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (minutes === 0) {
      return `${hours} Hour${hours > 1 ? "s" : ""}`;
    }

    return `${hours} Hour${hours > 1 ? "s" : ""} ${minutes} Min`;
  };


  return (
    <Paper
      sx={{
        paddingTop: 2,
        borderRadius: 2,
        px: "2%",
      }}
      elevation={0}
      style={{ width: "100%" }}
    >
      <LandingScreenHeader
        screenTitle={"Timeline"}
        showAddButton={false}
        showBackButton={true}
        onCancel={onCancel}
      />

      {showTimelineManagerLogs == 1 && (
        <Grid container marginTop="20px" marginLeft="4px" spacing={4}>
          {/* Sales Team Section with Info/Collapse Icon */}
          <Grid
            container
            md={12}
            lg={12}
            xs={12}
            sm={12}
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid
              item
              md={5}
              lg={5}
              xs={5}
              sm={5}
              style={{ display: "flex", alignItems: "center" }}
            >
              <LabelCompo
                className="text-black"
                style={{
                  fontSize: 16,
                  color: titleColor,
                  marginLeft: "14px",
                }}
                label="Sales Team :"
              />
            </Grid>

            <Grid
              item
              md={5}
              lg={5}
              xs={5}
              sm={5}
              style={{ display: "flex", alignItems: "center" }}
            >
              <span
                style={{
                  fontSize: 16,
                  color: blackColor,
                  wordWrap: "break-word",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  width: "auto",
                }}
              >
                {salesTeamData !== null ? salesTeamData.salesTeamName : "-"}
              </span>
            </Grid>

            <Grid
              item
              md={0.5}
              lg={0.5}
              xs={0.5}
              sm={0.5}
              style={{ display: "flex", alignItems: "center" }}
            >
              <IconButton onClick={handleToggleExpand} size="small">
                {isExpanded ? (
                  <ExpandLessIcon style={{ color: titleColor, fontSize: 20 }} />
                ) : (
                  <InfoOutlinedIcon
                    style={{ color: titleColor, fontSize: 20 }}
                  />
                )}
              </IconButton>
            </Grid>
          </Grid>

          {/* Collapsible Sections */}
          {isExpanded && (
            <>
              {/* Sales Team Type */}
              <Grid
                container
                md={12}
                lg={12}
                xs={12}
                sm={12}
                justifyContent="flex-start"
                alignItems="flex-start"
              >
                <Grid item md={5} lg={5} xs={5} sm={5}>
                  <LabelCompo
                    className="text-black"
                    style={{
                      fontSize: 16,
                      color: titleColor,
                      marginTop: "9px",
                      marginLeft: "14px",
                    }}
                    label="Type :"
                  />
                </Grid>

                <Grid item md={5} lg={5} xs={5} sm={5}>
                  <span
                    style={{
                      fontSize: 16,
                      color: blackColor,
                      display: "block",
                      wordWrap: "break-word",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      marginTop: "10px",
                    }}
                  >
                    {salesTeamData !== null ? salesTeamData.salesTeamType : "-"}
                  </span>
                </Grid>
              </Grid>

              {/* Beat, Area & Distance Travelled Section */}
              <Grid
                container
                md={12}
                lg={12}
                xs={12}
                sm={12}
                justifyContent="flex-start"
                alignItems="flex-start"
              >
                <Grid item md={5} lg={5} xs={5} sm={5}>
                  <LabelCompo
                    className="text-black"
                    style={{
                      fontSize: 16,
                      color: titleColor,
                      marginTop: "9px",
                      marginLeft: "14px",
                    }}
                    label="Beat :"
                  />
                </Grid>

                <Grid item md={5} lg={5} xs={5} sm={5}>
                  <span
                    style={{
                      fontSize: 16,
                      color: blackColor,
                      display: "block",
                      wordWrap: "break-word",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      marginTop: "10px",
                      width: "90%",
                    }}
                  >
                    {selectedBeatData !== null ? selectedBeatData : "-"}
                  </span>
                </Grid>
              </Grid>

              <Grid
                container
                md={12}
                lg={12}
                xs={12}
                sm={12}
                justifyContent="flex-start"
                alignItems="flex-start"
              >
                <Grid item md={5} lg={5} xs={5} sm={5}>
                  <LabelCompo
                    className="text-black"
                    style={{
                      fontSize: 16,
                      color: titleColor,
                      marginTop: "9px",
                      marginLeft: "14px",
                    }}
                    label="Area :"
                  />
                </Grid>

                <Grid item md={5} lg={5} xs={5} sm={5}>
                  <span
                    style={{
                      fontSize: 16,
                      color: blackColor,
                      display: "block",
                      wordWrap: "break-word",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      marginTop: "10px",
                      width: "90%",
                    }}
                  >
                    {selectedBeatArea !== null ? selectedBeatArea : "-"}
                  </span>
                </Grid>
              </Grid>

              {localStorage.getItem("showRealTimeTracking") == 1 && (
                <Grid
                  container
                  md={12}
                  lg={12}
                  xs={12}
                  sm={12}
                  justifyContent="flex-start"
                  alignItems="flex-start"
                >
                  <Grid item md={5} lg={5} xs={5} sm={5}>
                    <LabelCompo
                      className="text-black"
                      style={{
                        fontSize: 16,
                        color: titleColor,
                        marginTop: "9px",
                        marginLeft: "14px",
                      }}
                      label="Distance Travelled :"
                    />
                  </Grid>

                  <Grid item md={5} lg={5} xs={5} sm={5}>
                    <span
                      style={{
                        fontSize: 16,
                        color: blackColor,
                        display: "block",
                        wordWrap: "break-word",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        marginTop: "10px",
                        width: "90%",
                      }}
                    >
                      {distanceTravelled !== null
                        ? distanceTravelled + " KM"
                        : "-"}
                    </span>
                  </Grid>
                </Grid>
              )}
            </>
          )}

          {localStorage.getItem("showRealTimeTracking") !== null &&
            localStorage.getItem("showRealTimeTracking") == 1 && (
              <>
                <Grid
                  container
                  md={12}
                  lg={12}
                  xs={12}
                  sm={12}
                  justifyContent="flex-start"
                  marginLeft={0}
                  spacing={2}
                >
                  <Grid item xs={12} sm="auto" md="auto">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedOption == 0}
                          disabled={!areMapOptionsReady}
                          onChange={() =>
                            handleMainCheckboxChange(
                              selectedOption == 0 ? null : 0
                            )
                          }
                          value={0}
                        />
                      }
                      label="Tracking"
                    />
                  </Grid>

                  <Grid item xs={12} sm="auto" md="auto">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedOption == 1}
                          disabled={!areMapOptionsReady}
                          onChange={() =>
                            handleMainCheckboxChange(
                              selectedOption == 1 ? null : 1
                            )
                          }
                          value={1}
                        />
                      }
                      label="Outlet"
                    />
                  </Grid>

                  <Grid item xs={12} sm="auto" md="auto">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedOption == 2}
                          disabled={!areMapOptionsReady}
                          onChange={() =>
                            handleMainCheckboxChange(
                              selectedOption == 2 ? null : 2
                            )
                          }
                          value={2}
                        />
                      }
                      label="Activity"
                    />
                  </Grid>
                </Grid>

                <Grid
                  container
                  md={12}
                  lg={12}
                  xs={12}
                  sm={12}
                  justifyContent="flex-start"
                  marginLeft={0}
                  spacing={2}
                  marginTop={-4}
                >
                  <Grid item xs={12} sm="auto" md="auto">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedOption == 3}
                          disabled={!areMapOptionsReady}
                          onChange={() =>
                            handleMainCheckboxChange(
                              selectedOption == 3 ? null : 3
                            )
                          }
                          value={3}
                        />
                      }
                      label="Time Delay"
                    />
                  </Grid>

                  {localStorage.getItem("isShowSalesTeamHomeAddress") == 1 && (
                    <Grid item sx={{ ml: -2.2 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectedOption == 4}
                            disabled={!areMapOptionsReady}
                            onChange={() =>
                              handleMainCheckboxChange(
                                selectedOption == 4 ? null : 4
                              )
                            }
                            value={4}
                          />
                        }
                        label="Home Address"
                      />
                    </Grid>
                  )}
                </Grid>

                {/* Outlet or Activity UI */}
                {selectedOption !== null && (selectedOption == 1 || selectedOption == 2) && (
                  <Grid
                    container
                    spacing={2}
                    justifyContent="flex-start"
                    alignItems="center"
                    marginTop={1}
                  >
                    {selectedOption === 1 ? (
                      <Grid item xs={12}>
                        <div style={{ display: "flex", gap: "12px" }}>
                          <Grid item xs={12} sm="auto" md="auto">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "8px",
                                marginLeft: "-4px",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                }}
                              >
                                <img
                                  src={retailingImg}
                                  alt="outlet"
                                  style={{
                                    width: "24px",
                                    height: "24px",
                                    cursor: "pointer",
                                  }}
                                />
                                <span
                                  style={{ fontSize: 14, marginLeft: "8px" }}
                                >
                                  Normal Order
                                </span>
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                }}
                              >
                                <img
                                  src={zeroOrderIconImg}
                                  alt="outlet"
                                  style={{
                                    width: "24px",
                                    height: "24px",
                                    cursor: "pointer",
                                  }}
                                />
                                <span
                                  style={{ fontSize: 14, marginLeft: "8px" }}
                                >
                                  Zero Order
                                </span>
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                }}
                              >
                                <img
                                  src={unVisitedOutletIcon}
                                  alt="outlet"
                                  style={{
                                    width: "24px",
                                    height: "24px",
                                    cursor: "pointer",
                                  }}
                                />
                                <span
                                  style={{ fontSize: 14, marginLeft: "8px" }}
                                >
                                  Unvisited Outlet
                                </span>
                              </div>
                            </div>
                          </Grid>
                        </div>
                      </Grid>
                    ) : selectedOption === 2 ? (
                      // Activity checkboxes section (shared by Activity and Tracking With Activity)
                      <Grid item xs={12}>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(3, 150px)",
                            rowGap: "15px",
                            marginTop: "-20px",
                          }}
                        >
                          {[
                            { id: "1", img: checkInImg, label: "Check In" },
                            {
                              id: "2",
                              img: retailingImg,
                              label: "Normal Order",
                            },
                            {
                              id: "3",
                              img: zeroOrderIconImg,
                              label: "Zero Order",
                            },
                            { id: "4", img: otherWorkImg, label: "Other Work" },
                            {
                              id: "5",
                              img: officeWorkImg,
                              label: "Office Work",
                            },
                            {
                              id: "6",
                              img: distributorImg,
                              label: "Distributor Work",
                            },
                            { id: "7", img: jointWorkImg, label: "Joint Work" },
                            { id: "8", img: checkOutImg, label: "Check Out" },
                          ].map(({ id, img, label }) => (
                            <div
                              key={id}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                              }}
                            >

                              <Checkbox
                                checked={selectedActivities.includes(img)}
                                onChange={() => handleCheckboxChange(img)}
                                sx={{
                                  padding: 0,
                                  marginRight: "2px",
                                  '& .MuiSvgIcon-root': {
                                    fontSize: 20,
                                  }
                                }}
                              />
                              <img
                                src={img}
                                alt={label}
                                style={{
                                  width: "22px",
                                  height: "22px",
                                  marginRight: "6px",
                                }}
                              />
                              <span style={{ fontSize: 14 }}>{label}</span>
                            </div>
                          ))}
                        </div>
                      </Grid>
                    ) : null}
                  </Grid>
                )}
              </>
            )}
        </Grid>
      )}
      <br />

      {/*Tejas - Remove date validtion for manager log timeline */}
      {showTimelineManagerLogs == 1 ? (
        <Grid display={"flex"} md={12} lg={12} flexDirection={"row"}>
          <Grid
            item
            sm={6}
            xs={7}
            md={6}
            lg={6}
            container
            justifyContent="space-evenly"
          >
            <Grid item xs={12} md={10} sm={10}>
              <LabelCompo
                className="text-black"
                style={{ fontSize: 16, color: redColor }}
                label="* "
              />
              <LabelCompo
                className="text-black"
                style={{ fontSize: 16, color: titleColor }}
                label="From Date :"
              />
            </Grid>
            <Grid item xs={12} md={10} sm={10}>
              <BasicDatePicker
                color="primary"
                name="fromdate"
                size="small"
                value={fromdate}
                disabled={false}
                fullWidth
                onChange={changeDate("fromdate")}
                errorText={
                  formErrors["fromdateError"] ? formErrors["fromdateError"] : ""
                }
                isError={
                  formErrors["fromdateError"] ? formErrors["fromdateError"] : ""
                }
              />
            </Grid>
          </Grid>
          <Grid
            item
            sm={6}
            xs={7}
            md={6}
            lg={6}
            container
            justifyContent="space-evenly"
          >
            <Grid item xs={12} md={10} sm={10}>
              <LabelCompo
                className="text-black"
                style={{ fontSize: 16, color: redColor }}
                label="* "
              />
              <LabelCompo
                className="text-black"
                style={{ fontSize: 16, color: titleColor }}
                label="To Date :"
              />
            </Grid>
            <Grid item xs={12} md={10} sm={10}>
              <BasicDatePicker
                color="primary"
                name="todate"
                size="small"
                value={todate}
                minDate={fromdate}
                disabled={false}
                fullWidth
                onChange={changeDate("todate")}
                errorText={
                  formErrors["todateError"] ? formErrors["todateError"] : ""
                }
                isError={
                  formErrors["todateError"] ? formErrors["todateError"] : ""
                }
              />
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid display={"flex"} md={12} lg={12} flexDirection={"row"}>
          <Grid
            item
            sm={6}
            xs={7}
            md={6}
            lg={6}
            container
            justifyContent="space-evenly"
          >
            <Grid item xs={12} md={10} sm={10}>
              <LabelCompo
                className="text-black"
                style={{ fontSize: 16, color: redColor }}
                label="* "
              />
              <LabelCompo
                className="text-black"
                style={{ fontSize: 16, color: titleColor }}
                label="From Date :"
              />
            </Grid>
            <Grid item xs={12} md={10} sm={10}>
              <BasicDatePicker
                color="primary"
                name="fromdate"
                size="small"
                value={fromdate}
                disabled={false}
                fullWidth
                onChange={changeDate("fromdate")}
                errorText={
                  formErrors["fromdateError"] ? formErrors["fromdateError"] : ""
                }
                isError={
                  formErrors["fromdateError"] ? formErrors["fromdateError"] : ""
                }
              />
            </Grid>
          </Grid>

          <Grid
            item
            sm={6}
            xs={7}
            md={6}
            lg={6}
            container
            justifyContent="space-evenly"
          >
            <Grid item xs={12} md={10} sm={10}>
              <LabelCompo
                className="text-black"
                style={{ fontSize: 16, color: redColor }}
                label="* "
              />
              <LabelCompo
                className="text-black"
                style={{ fontSize: 16, color: titleColor }}
                label="To Date :"
              />
            </Grid>
            <Grid item xs={12} md={10} sm={10}>
              <BasicDatePicker
                color="primary"
                name="todate"
                size="small"
                value={todate}
                minDate={fromdate}
                maxDate={dayjs().subtract(1, "day")}
                disabled={false}
                fullWidth
                onChange={changeDate("todate")}
                errorText={
                  formErrors["todateError"] ? formErrors["todateError"] : ""
                }
                isError={
                  formErrors["todateError"] ? formErrors["todateError"] : ""
                }
              />
            </Grid>
          </Grid>
        </Grid>
      )}

      {/* <DialogActions> */}

      <Grid
        display={"flex"}
        mt={"5%"}
        justifyContent={"flex-end"}
        item
        sx={{ mr: -2 }}
        xs={12}
        sm={12}
        md={12}
      >
        <ButtonCompo
          size="medium"
          onClick={searchData}
          variant="contained"
          name="Search"
        />
      </Grid>
      {/* </DialogActions> */}

      <Box height={"610px"} overflow={"scroll"}>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Tabs
              variant="scrollable"
              aria-label="scrollable force tabs example"
              value={value}
              onChange={handleChange}
              style={{ overflow: "auto", width: "100%" }}
            >
              {showTimelineManagerLogs == 0
                ? location.salesTeamTimeline.map((salesTeamData, index) => (
                  <Tab key={index} label={salesTeamData.day} />
                ))
                : managerLogsList.managerLogs.map((managerLogData, index) => (
                  <Tab key={index} label={managerLogData.day} />
                ))}
            </Tabs>
            {showTimelineManagerLogs == 0
              ? location.salesTeamTimeline.map((salesTeamData, index) => {
                let totalAmount = 0;
                if (salesTeamData?.timelineData?.length !== 0) {
                  salesTeamData.timelineData.map((data) => {
                    totalAmount += +data.amount;
                  });
                }

                return (
                  <TabPanel key={index} value={value} index={index}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <LabelCompo
                        className="text-black"
                        style={{ fontSize: 16, color: titleColor }}
                        label="Beat Names :"
                      />{" "}
                      <LabelCompo
                        className="text-black"
                        style={{ fontSize: 16 }}
                        label={
                          rows[index]?.timelineData.length !== 0
                            ? rows[index]?.timelineData[0].beatName
                            : "-"
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <LabelCompo
                        className="text-black"
                        style={{ fontSize: 16, color: titleColor }}
                        label="Total Amount :"
                      />{" "}
                      <LabelCompo
                        className="text-black"
                        style={{ fontSize: 16 }}
                        label={
                          totalAmount !== 0 ? (+totalAmount).toFixed(2) : "-"
                        }
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <LabelCompo
                        className="text-black"
                        style={{ fontSize: 16, color: titleColor }}
                        label="Distance Travelled :"
                      />{" "}
                      <LabelCompo
                        className="text-black"
                        style={{ fontSize: 16 }}
                        label={
                          (rows.length !== 0 && Object.keys(rows[index]?.totalData).length !== 0
                            ? rows[index]?.totalData?.distanceTravelled.toFixed(2)
                            : "-") + " km"
                        }
                      />
                    </Grid>
                    <TableContainer sx={{ width: "maxContent" }}>
                      <Table
                        sx={{ minWidth: "maxContent" }}
                        aria-label="simple table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">#</TableCell>
                            <TableCell align="center">Time</TableCell>
                            <TableCell align="center">Outlet Name</TableCell>
                            <TableCell align="center">Amount</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows[index]?.timelineData.map(
                            (rowData, rowIndex) => (
                              <TableRow key={rowData.index}>
                                <TableCell align="center">
                                  {rowData.index + 1}
                                </TableCell>
                                <TableCell align="center">
                                  {rowData.time}
                                </TableCell>
                                <TableCell align="left">
                                  <div
                                    onClick={() => timelineDetails(rowData)}
                                    style={{
                                      color: cyanBlue,
                                      cursor: "pointer",
                                    }}
                                  >
                                    {rowData.outletName}
                                  </div>
                                </TableCell>
                                <TableCell align="right">
                                  {rowData.amount}
                                </TableCell>
                              </TableRow>
                            )
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </TabPanel>
                );
              })
              :
              //Time Delay Timeline UI ->
              (selectedOption == 3 ? (
                pathCoords.length !== 0 &&
                pathCoords.map((mnglogObj, index) => {
                  const timeDelayDataObj = {
                    index: index + 1,
                    lattitude: mnglogObj.lat,
                    longittude: mnglogObj.lng,
                    prevTime: mnglogObj.prevTime.split(":").slice(0, 2).join(":"),
                    currentTime: mnglogObj.insertTime.split(":").slice(0, 2).join(":"),
                    gapTime: Math.round(mnglogObj.gapTime),
                  };
                  return (
                    <>
                      <div
                        style={cssStyle.cardStyleForTimeLineDelay}
                        key={index}
                        onClick={() => handleTabClickForTimeDelay(timeDelayDataObj)
                        }
                      >
                        {/* Header with gradient and icon */}
                        <div style={cssStyle.headerStyleForTimeDelay}>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="white"
                            style={{ marginRight: "8px", verticalAlign: "middle" }}
                          >
                            <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                          </svg>
                          <span style={{ verticalAlign: "middle" }}>
                            {timeDelayDataObj.prevTime} To {timeDelayDataObj.currentTime}
                          </span>
                          <span style={{
                            marginLeft: "auto",
                            backgroundColor: "rgba(255, 255, 255, 0.25)",
                            padding: "4px 12px",
                            borderRadius: "20px",
                            fontSize: "13px",
                            fontWeight: "600"
                          }}>
                            {formatGapTime(timeDelayDataObj.gapTime)}
                          </span>
                        </div>

                        {/* Content with modern card design */}
                        <div style={cssStyle.contentWrapperStyle}>
                          {/* Time Delay Badge */}
                          <div style={cssStyle.infoRowStyle}>
                            <div style={cssStyle.labelStyle}>
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="#f44336" style={{ marginRight: "6px" }}>
                                <path d="M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z" />
                              </svg>
                              <span>Time Delay</span>
                            </div>
                            <div style={cssStyle.valueStyle}>
                              <span style={cssStyle.delayBadgeStyle}>
                                {formatGapTime(timeDelayDataObj.gapTime)}
                              </span>
                              <span style={{ fontSize: "12px", color: "#666", marginLeft: "6px" }}>
                                from last location
                              </span>
                            </div>
                          </div>

                          {/* Current Time */}
                          <div style={cssStyle.infoRowStyle}>
                            <div style={cssStyle.labelStyle}>
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="#2196F3" style={{ marginRight: "6px" }}>
                                <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
                                <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                              </svg>
                              <span>Time</span>
                            </div>
                            <div style={cssStyle.valueStyle}>
                              {timeDelayDataObj.currentTime}
                            </div>
                          </div>
                        </div>
                      </div >
                    </>
                  );
                })
              ) :
                //Regular Timeline ->
                (
                  rows.length !== 0 &&
                  rows.map(
                    (managerLogHeaderObj, index) =>
                      Array.isArray(managerLogHeaderObj?.managerLogs) &&
                      managerLogHeaderObj?.managerLogs
                        .filter((row) => row.flag == 1)
                        .map((mnglogObj, subIndex) => {
                          const itemObject = {
                            id: mnglogObj.id,
                            date: managerLogHeaderObj.date,
                            label1: "Amount",
                            label2: "Product Count",
                            onPressLabel2Flag: true,
                            label3: "Qty",
                            outletOrderHeaderId: mnglogObj.extraIds
                              ? mnglogObj.extraIds
                              : "",
                            outletId: mnglogObj.outletId
                              ? mnglogObj.outletId
                              : "",
                            isVisitIsOrder: mnglogObj.isVisitIsOrder,
                            remoteOrder: mnglogObj.remoteOrder,
                            value1: mnglogObj.description
                              ? mnglogObj.description
                              : 0,
                            value2: mnglogObj.extra1 ? mnglogObj.extra1 : "",
                            value3: mnglogObj.amount,
                            value4: mnglogObj.remarkName,
                            valueColor3: blackColor,
                            workingTypeName: mnglogObj.workingTypeName,
                            headerName:
                              mnglogObj.workingTypeId == 5 &&
                                mnglogObj.otherTaskId == 3
                                ? mnglogObj.description
                                : mnglogObj.otherTaskId == 4
                                  ? mnglogObj.salesTeamName
                                  : mnglogObj.otherTaskId == 1 &&
                                    mnglogObj.workingTypeId == 1 &&
                                    mnglogObj.isVisitIsOrder == "1"
                                    ? `${mnglogObj.entityName} (${"Zero " + mnglogObj.workingTypeName
                                    })`
                                    : mnglogObj.otherTaskId == 6 &&
                                      mnglogObj.workingTypeId == 5
                                      ? `${mnglogObj.entityName} `
                                      : `${mnglogObj.entityName} (${mnglogObj.workingTypeName})`,

                            industryIconFlag:
                              (mnglogObj.otherTaskId == 5 &&
                                (mnglogObj.checkInOut == 0 ||
                                  mnglogObj.checkInOut == 1)) ||
                                (mnglogObj.workingTypeId == 5 &&
                                  mnglogObj.otherTaskId == 3) ||
                                mnglogObj.otherTaskId == 4 ||
                                mnglogObj.otherTaskId == 6
                                ? false
                                : true,

                            jointWorkIconFlag:
                              mnglogObj.otherTaskId == 4 ||
                                mnglogObj.otherTaskId == 6
                                ? true
                                : false,
                            subHeaderFlag: !(
                              mnglogObj.workingTypeId == 0 ||
                              mnglogObj.otherTaskId == 3
                            ),
                            subHeaderName:
                              mnglogObj.otherTaskId != 5 &&
                                mnglogObj.workingTypeId != 1
                                ? mnglogObj.description
                                : "",

                            timelineFlag: true,
                            color: mnglogObj.color,
                            workTypeFlag: 3,
                            timelineWorkTypeFlag: !(
                              mnglogObj.otherTaskId == 5 &&
                              (mnglogObj.checkInOut == 0 ||
                                mnglogObj.checkInOut == 1)
                            ),
                            workType: mnglogObj.otherTaskId,
                            timelineHeaderFlag: true,
                            timelineHeaderValue: mnglogObj.fromTime,
                            timeDifference: mnglogObj.timeDifference,
                            toTime: mnglogObj.toTime,
                            checkInOutStatus:
                              mnglogObj.otherTaskId == 5 &&
                              mnglogObj.checkInOut == 0,
                            checkInOutStatusFlag:
                              mnglogObj.otherTaskId == 5 &&
                              (mnglogObj.checkInOut == 0 ||
                                mnglogObj.checkInOut == 1),
                            detailsFlag:
                              ((mnglogObj.otherTaskId == 1 ||
                                mnglogObj.otherTaskId == 2) &&
                                mnglogObj.workingTypeId == 1) ||
                                mnglogObj.workingTypeId == 14 ||
                                mnglogObj.workingTypeId == 15
                                ? 1
                                : 0,
                            workingTypeId: mnglogObj.workingTypeId,
                            managerStartLat: mnglogObj.managerStartLat,
                            managerStartLong: mnglogObj.managerStartLong,
                            startTime: mnglogObj.fromTime,
                            endTime: mnglogObj.toTime,
                            outletName: mnglogObj.entityName,
                            stockStakeHolderName: mnglogObj.stockStakeHolderName,
                            remoteOrder: mnglogObj.remoteOrder,
                            checkInOut: mnglogObj.checkInOut,
                            outletLat: mnglogObj.outletLatitude,
                            outletLong: mnglogObj.outletLongitude,
                            image: mnglogObj.image,
                            entityName: mnglogObj.entityName,
                          };

                          return (
                            <>
                              <TabPanel key={index} value={value} index={index}>
                                <div style={cssStyle.cardStyle} key={index - subIndex}>
                                  {itemObject.timelineHeaderFlag && (
                                    <div style={cssStyle.headerStyle}>
                                      {itemObject.checkInOutStatusFlag
                                        ? itemObject.checkInOut == 0
                                          ? itemObject.timelineHeaderValue +
                                          (itemObject.timeDifference
                                            ? " (" +
                                            padTime(itemObject.timeDifference) +
                                            ")"
                                            : "")
                                          : itemObject.endTime
                                        : itemObject.timelineHeaderValue +
                                        " To " +
                                        itemObject.toTime +
                                        (itemObject.timeDifference
                                          ? " (" +
                                          padTime(itemObject.timeDifference) +
                                          ")"
                                          : "")}
                                    </div>
                                  )}

                                  {itemObject.checkInOutStatusFlag && (
                                    <div
                                      style={{
                                        ...statusStyle(itemObject.checkInOutStatus),
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "0 5px",
                                      }}
                                      onClick={
                                        checkInImageFlag == 1 &&
                                          itemObject.checkInOutStatus
                                          ? () => handleCheckInClick(itemObject)
                                          : () => handleTabClick(itemObject)
                                      }
                                    >
                                      <span>
                                        {itemObject.checkInOutStatus
                                          ? "Check In"
                                          : "Check Out"}
                                      </span>
                                      {checkInImageFlag == 1 &&
                                        itemObject.checkInOutStatus && (
                                          <>
                                            <MyComponentWithIconProps
                                              statusImage={VisibilityIcon}
                                              color="black"
                                              fontSize="medium"
                                              title="View Selfie"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleCheckInClick(itemObject);
                                              }}
                                            />
                                          </>
                                        )}
                                    </div>
                                  )}

                                  {itemObject.timelineWorkTypeFlag && (
                                    <>
                                      <div
                                        style={{
                                          ...workStyle(itemObject),
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          padding: "0 5px",
                                        }}
                                        onClick={
                                          zeroOrderImageFlag == 1 &&
                                            itemObject.workType == 1 &&
                                            itemObject.workingTypeId == 1 &&
                                            itemObject.workingTypeId != 5 &&
                                            itemObject.isVisitIsOrder == 1
                                            ? () => handleZeroOrderImage(itemObject)
                                            : itemObject.workType == 6 && itemObject.workingTypeId == 21 ? null : () => handleTabClick(itemObject)
                                        }
                                      >
                                        {(itemObject.workType == 1 &&
                                          itemObject.workingTypeId == 1) ||
                                          (itemObject.workingTypeId == 4 &&
                                            itemObject.workType == 1) ||
                                          (itemObject.workingTypeId == 31 &&
                                            itemObject.workType == 15)
                                          ? "Retailing"
                                          : itemObject.workType == 2 &&
                                            itemObject.workingTypeId != 5
                                            ? "Distributor Work"
                                            : itemObject.workType == 3
                                              ? "Office Work"
                                              : itemObject.workType == 4
                                                ? "Joint Work"
                                                : itemObject.workingTypeId == 5 &&
                                                  itemObject.workType == 7
                                                  ? itemObject.otherTaskName
                                                  : itemObject.workingTypeId == 13 &&
                                                    itemObject.workType == 8
                                                    ? "Survey"
                                                    : itemObject.workType == 1 &&
                                                      itemObject.workingTypeId == 16
                                                      ? "Outlet Add"
                                                      : itemObject.workType == 11 &&
                                                        itemObject.workingTypeId == 4
                                                        ? "Feedback"
                                                        : "Other Work"}

                                        {zeroOrderImageFlag == 1 &&
                                          itemObject.workType == 1 &&
                                          itemObject.workingTypeId != 5 &&
                                          itemObject.workType == 1 &&
                                          itemObject.workingTypeId != 4 &&
                                          itemObject.isVisitIsOrder == 1 &&
                                          itemObject.image != null &&
                                          itemObject.image != "" && (
                                            <>
                                              <MyComponentWithIconProps
                                                statusImage={VisibilityIcon}
                                                color="black"
                                                fontSize="medium"
                                                title="View Image"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleZeroOrderImage(itemObject);
                                                }}
                                              />
                                            </>
                                          )}

                                        {(itemObject.workType == 1 ||
                                          itemObject.workingTypeId == 4) &&
                                          (itemObject.workType == 2 ||
                                            itemObject.workingTypeId == 4) && (
                                            <>
                                              <MyComponentWithIconProps
                                                statusImage={VisibilityIcon}
                                                color="black"
                                                fontSize="medium"
                                                title="Feedback Image"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleFeedbackImage(itemObject);
                                                }}
                                              />
                                            </>
                                          )}

                                        {(itemObject.workType == 6 &&
                                          itemObject.workingTypeId == 21) && (
                                            <>
                                              <MyComponentWithIconProps
                                                statusImage={VisibilityIcon}
                                                color="black"
                                                fontSize="medium"
                                                title={itemObject.workingTypeName}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handlePromoterData(itemObject);
                                                }}
                                              />
                                            </>
                                          )}
                                      </div>

                                      <div style={cssStyle.detailBoxStyle}>
                                        <div style={cssStyle.headerSubHeaderStyle}>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "400",
                                              display: "flex",
                                              alignItems: "center",
                                              whiteSpace: "pre-line", // Tejas - This is use for \n as line breaks
                                            }}
                                          >
                                            {itemObject.industryIconFlag ? (
                                              itemObject.remoteOrder == 1 ? (
                                                <>
                                                  <CottageIcon
                                                    style={{
                                                      verticalAlign: "middle",
                                                      marginRight: "8px",
                                                    }}
                                                  />

                                                  {itemObject.headerName}
                                                  {itemObject.stockStakeHolderName !==
                                                    null &&
                                                    itemObject.stockStakeHolderName !==
                                                    "" ? (
                                                    <span
                                                      style={{
                                                        fontWeight: "normal",
                                                      }}
                                                    >
                                                      (Order To:{" "}
                                                      {
                                                        itemObject.stockStakeHolderName
                                                      }
                                                      )
                                                    </span>
                                                  ) : null}

                                                  <span
                                                    style={{
                                                      backgroundColor: "red",
                                                      color: "white",
                                                      padding: "4px 8px",
                                                      marginLeft: "12px",
                                                    }}
                                                  >
                                                    Remote Order
                                                  </span>
                                                </>
                                              ) : (
                                                <>
                                                  <CottageIcon
                                                    style={{
                                                      verticalAlign: "middle",
                                                      marginRight: "8px",
                                                    }}
                                                  />
                                                  {itemObject.headerName}
                                                  {itemObject.isVisitIsOrder ==
                                                    "0" &&
                                                    itemObject.workType == 1 &&
                                                    itemObject.workingTypeId !=
                                                    16 &&
                                                    (itemObject.stockStakeHolderName !==
                                                      null &&
                                                      itemObject.stockStakeHolderName !==
                                                      "" ? (
                                                      <span
                                                        style={{
                                                          fontWeight: "normal",
                                                        }}
                                                      >
                                                        (Order To:{" "}
                                                        {
                                                          itemObject.stockStakeHolderName
                                                        }
                                                        )
                                                      </span>
                                                    ) : null)}
                                                </>
                                              )
                                            ) : itemObject.jointWorkIconFlag ? (
                                              <>
                                                {(itemObject.workingTypeId != 5 ||
                                                  itemObject.workType != 6 ||
                                                  itemObject.entityName != "") &&
                                                  (itemObject.workingTypeId == 5 ||
                                                    itemObject.workType == 4) && (
                                                    <PersonIcon
                                                      style={{
                                                        verticalAlign: "middle",
                                                        marginRight: "8px",
                                                      }}
                                                    />
                                                  )}

                                                {itemObject.headerName}
                                              </>
                                            ) : (
                                              <>
                                                <div
                                                  style={{
                                                    marginLeft: "5px",
                                                    whiteSpace: "pre-line",
                                                  }}
                                                />
                                                {itemObject.headerName}
                                              </>
                                            )}
                                          </div>

                                          {itemObject.subHeaderFlag &&
                                            mnglogObj.workType != 1 &&
                                            mnglogObj.workingTypeId != 14 &&
                                            mnglogObj.workingTypeId != 15 && (
                                              <div
                                                style={{
                                                  fontSize: "12px",
                                                  fontWeight: "350",
                                                  marginTop: "8px",
                                                  marginLeft: "32px",
                                                  whiteSpace: "pre-line",
                                                }}
                                              >
                                                {itemObject.subHeaderName}
                                              </div>
                                            )}
                                        </div>

                                        {itemObject.workTypeFlag == 1 ? (
                                          <div style={{ padding: 5 }}>
                                            <div
                                              style={{
                                                backgroundColor: greyColor,
                                                width: "98%",
                                                borderRadius: 2,
                                                justifyContent: "space-between",
                                                flexDirection: "row",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  backgroundColor: itemObject.color,
                                                  width: "35%",
                                                  borderRadius: 2,
                                                  padding: 2,
                                                  display: "flex",
                                                  justifyContent: "space-between",
                                                  flexDirection: "row",
                                                }}
                                              >
                                                <p
                                                  style={{
                                                    color: blackColor,
                                                    fontSize: 14,
                                                    fontWeight: 500,
                                                    fontFamily:
                                                      "Poppins, sans-serif",
                                                    position: "relative",
                                                    alignSelf: "flex-start",
                                                    marginLeft: 2,
                                                  }}
                                                >
                                                  {itemObject.workTypeName
                                                    ? itemObject.workTypeName
                                                    : itemObject.workType}
                                                </p>
                                              </div>

                                              <p
                                                style={{
                                                  color: blackColor,
                                                  fontSize: 14,
                                                  fontWeight: 500,
                                                  fontFamily: "poppinsMedium",
                                                  position: "relative",
                                                  alignSelf: "flex-start",
                                                  marginRight: 5,
                                                  padding: 2,
                                                }}
                                              >
                                                {itemObject.timeValue !== ""
                                                  ? itemObject.timeValue
                                                  : "-"}
                                              </p>
                                            </div>
                                          </div>
                                        ) : itemObject.workTypeFlag == 0 ? (
                                          <div style={{ padding: 5 }}>
                                            <div
                                              style={{
                                                backgroundColor: yellowColor,
                                                width: "98%",
                                                borderRadius: 2,
                                                padding: 2,
                                                justifyContent: "space-between",
                                                flexDirection: "row",
                                              }}
                                            >
                                              <p
                                                style={{
                                                  color: white,
                                                  fontSize: 14,
                                                  fontWeight: 500,
                                                  fontFamily: "poppinsMedium",
                                                  position: "relative",
                                                  alignSelf: "flex-start",
                                                  marginLeft: 2,
                                                }}
                                              >
                                                {itemObject.workTypeName
                                                  ? itemObject.workTypeName
                                                  : itemObject.workType}
                                              </p>
                                            </div>
                                          </div>
                                        ) : null}

                                        {itemObject.timelineFlag &&
                                          itemObject.detailsFlag == 1 && (
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "6px",
                                              }}
                                            >
                                              <div style={cssStyle.dataSectionStyle}>
                                                <span
                                                  style={{
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                  }}
                                                >
                                                  {itemObject.workType == 1 &&
                                                    itemObject.workingTypeId == 1 &&
                                                    itemObject.isVisitIsOrder ==
                                                    "1" &&
                                                    itemObject.value4 != null &&
                                                    itemObject.value4 != ""
                                                    ? itemObject.value4
                                                    : isFinite(itemObject.value1) &&
                                                      itemObject.value1 !== ""
                                                      ? Number(
                                                        itemObject.value1
                                                      ).toFixed(2)
                                                      : itemObject.value1}
                                                </span>
                                                {itemObject.value2 !== "" && (
                                                  <span
                                                    style={{
                                                      fontSize: "12px",
                                                      fontWeight: "500",
                                                    }}
                                                  >
                                                    {" "}
                                                    {itemObject.label1}
                                                  </span>
                                                )}
                                              </div>

                                              <div
                                                style={cssStyle.dataSectionStyle}
                                                onClick={() =>
                                                  handleClickOnProductCount(
                                                    itemObject
                                                  )
                                                }
                                              >
                                                <span
                                                  style={{
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                    color: cyanBlue,
                                                  }}
                                                >
                                                  {itemObject.value2}
                                                </span>
                                                {itemObject.value2 !== "" && (
                                                  <span
                                                    style={{
                                                      fontSize: "12px",
                                                      fontWeight: "500",
                                                      color: cyanBlue,
                                                    }}
                                                  >
                                                    {" "}
                                                    {itemObject.label2}
                                                  </span>
                                                )}
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                    </>
                                  )}
                                </div>
                              </TabPanel>
                            </>
                          );
                        })
                  )
                )
              )
            }
          </Grid>
        </Grid>
      </Box>

      {
        popUpFlag && (
          <TimelineDetailsPopup
            open={popUpFlag}
            handleCloses={handleClose}
            hideColumnsAtTimelineDetailsPopUp={hideColumnsAtTimelineDetailsPopUp}
            columns={
              hideColumnsAtTimelineDetailsPopUp
                ? []
                : showTimelineManagerLogs == 1
                  ? [
                    {
                      title: "Sr. No.",
                      name: "index",
                      positionCenter: false,
                      showInscreen: true,
                      alignCenter: "center",
                      canSearch: true,
                    },
                    {
                      title: "Product Name",
                      name: "productName",
                      positionCenter: false,
                      showInscreen: true,
                      alignCenter: "left",
                      canSearch: true,
                    },
                    {
                      title: "Focus Prodct",
                      name: "focusProduct",
                      positionCenter: false,
                      showInscreen: true,
                      alignCenter: "left",
                      canSearch: true,
                    },
                    {
                      title: "UOM",
                      name: "uom",
                      positionCenter: false,
                      showInscreen: true,
                      alignCenter: "center",
                      canSearch: true,
                    },
                    {
                      title: "Rate",
                      name: "rate",
                      positionCenter: false,
                      showInscreen: true,
                      alignCenter: "right",
                      canSearch: true,
                    },
                    {
                      title: "Quantity",
                      name: "qty",
                      positionCenter: false,
                      showInscreen: true,
                      alignCenter: "right",
                      canSearch: true,
                    },
                    {
                      title: "Discount(%)",
                      name: "discountPer",
                      positionCenter: false,
                      showInscreen: true,
                      alignCenter: "right",
                      canSearch: true,
                    },
                    {
                      title: "Total Amount",
                      name: "totalAmt",
                      positionCenter: false,
                      showInscreen: true,
                      alignCenter: "right",
                      canSearch: true,
                    },
                  ]
                  : [
                    {
                      title: "Sr. No.",
                      name: "index",
                      positionCenter: false,
                      showInscreen: true,
                      alignCenter: "center",
                      canSearch: true,
                    },
                    {
                      title: "Product Name",
                      name: "productName",
                      positionCenter: false,
                      showInscreen: true,
                      alignCenter: "left",
                      canSearch: true,
                    },
                    {
                      title: "UOM",
                      name: "uom",
                      positionCenter: false,
                      showInscreen: true,
                      alignCenter: "center",
                      canSearch: true,
                    },
                    {
                      title: "Rate",
                      name: "rate",
                      positionCenter: false,
                      showInscreen: true,
                      alignCenter: "right",
                      canSearch: true,
                    },
                    {
                      title: "Quantity",
                      name: "qty",
                      positionCenter: false,
                      showInscreen: true,
                      alignCenter: "right",
                      canSearch: true,
                    },
                    {
                      title: "Total Amount",
                      name: "totalAmt",
                      positionCenter: false,
                      showInscreen: true,
                      alignCenter: "right",
                      canSearch: true,
                    },
                  ]
            }
            rows={outletOrderDetails}
            rowsPastOrder={outletOrderDetailsPastOrder}
            rowsOffer={appliedOfferDetails}
            rowsPastOrderOffer={appliedOfferDetailsPastOrder}
            DataToSet={DataToSet}
            dataToSetPastOrder={dataToSetPastOrder}
            showTimelineManagerLogs={showTimelineManagerLogs}
            showPastOrderInTimeline={showPastOrderInTimeline}
          />
        )
      }

      {
        salesPersonCheckInImageFlag && (
          <SalesPersonCheckInImage
            open={salesPersonCheckInImageFlag}
            id={params.id}
            itemObject={itemObj}
            handleCloses={handleClosesSalesPersonImage}
          />
        )
      }

      {
        zeroOrderImgOpenFlag && (
          <ZeroOrderImage
            open={zeroOrderImgOpenFlag}
            itemObject={itemObj}
            handleCloses={handleClosesZeroOrderImage}
          />
        )
      }

      {
        feedbackImgOpenFlag && (
          <FeedbackImage
            open={feedbackImgOpenFlag}
            outletOrderHeaderId={itemObj.outletOrderHeaderId}
            itemObject={itemObj}
            handleCloses={handleClosesForFeedbackImage}
          />
        )
      }

      {promoterDataPopUpFlag && (
        <PromotoerDataPopUp
          open={promoterDataPopUpFlag}
          outletOrderHeaderId={itemObj.outletOrderHeaderId}
          itemObject={itemObj}
          handleCloses={handleClosesForPromoterDataPopUp}
        />
      )}
    </Paper >
  );
};

const mapStateToProps = (state) => ({
  location: state.location,
  managerLogsList: state.managerLogs,
});
const mapDispatchToProps = {
  showLoador,
  showNotification,
  getTimelineForSalesExecutive,
  getManagerLogsBySalesTeamIdsUpdated,
  getTimeLineForBelowSalesTeamsAndDates,
  setManagerLogs,
};
export default connect(mapStateToProps, mapDispatchToProps)(Timeline);

const cssStyle = {
  cardStyle: {
    padding: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 8px",
    borderRadius: "4px",
  },

  headerStyle: {
    fontSize: "15px",
    fontWeight: "500",
  },

  detailBoxStyle: {
    borderRadius: "1.5px",
    boxShadow: "rgba(0, 0, 0, 0.10) 0px 3px 8px",
    padding: "1.5px",
    backgroundColor: "white",
  },

  headerSubHeaderStyle: {
    gap: "8px",
    alignItems: "center",
  },

  dataSectionStyle: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    alignItems: "center",
    width: "40%",
  },

  cardStyleForTimeLineDelay: {
    padding: "0",
    display: "flex",
    flexDirection: "column",
    // boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    borderRadius: "12px",
    overflow: "hidden",
    background: "white",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    marginTop: "14px",
    border: "1px solid #d3d3d3",
  },

  headerStyleForTimeDelay: {
    fontSize: "15px",
    fontWeight: "600",
    background: "linear-gradient(135deg, #f44336 0%, #e91e63 100%)",
    color: "white",
    padding: "10px 14px",
    display: "flex",
    alignItems: "center",
    boxShadow: "0 2px 8px rgba(244, 67, 54, 0.3)",
  },

  contentWrapperStyle: {
    padding: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    background: "#fafafa",
  },

  infoRowStyle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px",
    background: "white",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
  },

  labelStyle: {
    display: "flex",
    alignItems: "center",
    fontSize: "13px",
    fontWeight: "600",
    color: "#555",
  },

  valueStyle: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#333",
    display: "flex",
    alignItems: "center",
  },

  delayBadgeStyle: {
    background: "linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%)",
    color: "white",
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "13px",
    fontWeight: "600",
    boxShadow: "0 2px 6px rgba(255, 107, 107, 0.3)",
  },

  locationContainerStyle: {
    display: "flex",
    gap: "5px",
    alignItems: "center",
    padding: "8px",
    background: "white",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
  },

  coordinateBoxStyle: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "8px",
    background: "linear-gradient(135deg, #f5f5f5 0%, #fafafa 100%)",
    borderRadius: "20px",
    border: "1px solid #eee",
  },

  coordinateDividerStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

}


const workStyle = (itemObject) => ({
  fontSize: "12px",
  fontWeight: "450",
  borderRadius: "6px",
  padding: "6px",
  minHeight: "27px",
  backgroundColor:
    (itemObject.workType == 1 || itemObject.workType == 15) &&
      itemObject.workingTypeId != 5 &&
      itemObject.workingTypeId != 16 &&
      itemObject.workingTypeId != 33 &&
      itemObject.workingTypeId != 32
      ? vividGreen // retailing
      : itemObject.workType == 2 && itemObject.workingTypeId != 5
        ? lightSkyBlue // distributor Work
        : itemObject.workType == 3
          ? periwinkleblue // office Work
          : itemObject.workType == 4
            ? lightOrange // joint Work
            : itemObject.workType == 8
              ? pastelPink
              : itemObject.workType == 1 && itemObject.workingTypeId == 16
                ? vividGreen //outlet Add
                : itemObject.workType == 11 && itemObject.workingTypeId == 4
                  ? lightGreen //feedback
                  : itemObject.workingTypeId == 13 && itemObject.workType == 8
                    ? brownishRed //survey
                    : lightGreen, //other work
});

const statusStyle = (isCheckIn) => ({
  fontSize: "12px",
  borderRadius: "6px",
  padding: "10px 6px",
  backgroundColor: isCheckIn ? DarkBlue : redColor,
  minHeight: "27px",
});

